import { collection, addDoc, getDocs, getDoc, doc, deleteDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

export const getAllBookings = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, 'bookings'));
    const bookings = [];
    querySnapshot.forEach((doc) => {
      bookings.push({ id: doc.id, ...doc.data() });
    });
    return { success: true, data: bookings };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const getBooking = async (id) => {
  try {
    const docRef = doc(db, 'bookings', id);
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
      return { success: true, data: { id: docSnap.id, ...docSnap.data() } };
    } else {
      return { success: false, error: 'Booking not found' };
    }
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const createBooking = async (bookingData) => {
  try {
    const docRef = await addDoc(collection(db, 'bookings'), {
      ...bookingData,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
    return { success: true, id: docRef.id };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const deleteBooking = async (id) => {
  try {
    await deleteDoc(doc(db, 'bookings', id));
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};